/* 92fa0c30470e020b6173619a1d55c429ae39ef6d
 * This file is automatically generated by graphql-let. */

import * as Types from '../../../../__types__';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AccountPackagesQueryVariables = Types.Exact<{
  locale: Types.Locale;
}>;


export type AccountPackagesQuery = { __typename?: 'Query', packageList?: Array<{ __typename?: 'Package', id?: string | null, title?: string | null, titleShort?: string | null, price?: number | null, currency?: Types.Currency | null, uri?: string | null, intention?: Types.PaymentIntention | null } | null> | null };


export const AccountPackagesDocument = gql`
    query AccountPackages($locale: Locale!) {
  packageList(locale: $locale, category: ACCOUNT) {
    id
    title(locale: $locale)
    titleShort(locale: $locale)
    price
    currency
    uri
    intention
  }
}
    `;

/**
 * __useAccountPackagesQuery__
 *
 * To run a query within a React component, call `useAccountPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountPackagesQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useAccountPackagesQuery(baseOptions: Apollo.QueryHookOptions<AccountPackagesQuery, AccountPackagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountPackagesQuery, AccountPackagesQueryVariables>(AccountPackagesDocument, options);
      }
export function useAccountPackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountPackagesQuery, AccountPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountPackagesQuery, AccountPackagesQueryVariables>(AccountPackagesDocument, options);
        }
export type AccountPackagesQueryHookResult = ReturnType<typeof useAccountPackagesQuery>;
export type AccountPackagesLazyQueryHookResult = ReturnType<typeof useAccountPackagesLazyQuery>;
export type AccountPackagesQueryResult = Apollo.QueryResult<AccountPackagesQuery, AccountPackagesQueryVariables>;